"use client";

import { Button, Dialog, HStack, Portal } from "@chakra-ui/react";

type ConfirmLeaveDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
};

export default function ConfirmLeaveDialog({
  open,
  onOpenChange,
  onConfirm,
  title = "Leave this game?",
  description = "You will lose your progress.",
}: ConfirmLeaveDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(details) => onOpenChange(details.open)}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner p={{ base: 4, md: 6 }}>
          <Dialog.Content maxW="sm" w="full">
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Dialog.Description color="fg.muted">{description}</Dialog.Description>
            </Dialog.Body>
            <Dialog.Footer>
              <HStack gap={3} w="full" flexWrap="wrap" justify="flex-end">
                <Dialog.ActionTrigger asChild>
                  <Button variant="outline" flex={{ base: "1 1 auto", sm: "initial" }}>
                    Cancel
                  </Button>
                </Dialog.ActionTrigger>
                <Button
                  colorPalette="red"
                  flex={{ base: "1 1 auto", sm: "initial" }}
                  onClick={() => {
                    onOpenChange(false);
                    onConfirm();
                  }}
                >
                  OK
                </Button>
              </HStack>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
